var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLoanDashboard = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33.997,
  height: 33.997,
  viewBox: "0 0 33.997 33.997",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1,.cls-12,.cls-6{fill:none}.cls-1,.cls-2{clip-rule:evenodd}.cls-2{fill:rgba(0,0,0,0)}.cls-3{clip-path:url(#clip-path)}.cls-4{fill:#fff}.cls-5{clip-path:url(#clip-path-2)}.cls-12,.cls-6{stroke:#5f7278}.cls-6{stroke-width:2px}.cls-7{clip-path:url(#clip-path-3)}.cls-8{fill:#5f7278}.cls-9{clip-path:url(#clip-path-4)}.cls-10{clip-path:url(#clip-path-5)}.cls-11{clip-path:url(#clip-path-6)}.cls-12{stroke-width:.3px}\n        "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_67",
  d: "M0-24h34v34H0z",
  className: "cls-1",
  "data-name": "Path 67",
  transform: "translate(0 24)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_69",
  d: "M4-7.959a12.041 12.041 0 0 0 12.041 12.04 12.041 12.041 0 0 0 12.04-12.04A12.041 12.041 0 0 0 16.041-20a11.751 11.751 0 0 0-7.668 2.774",
  className: "cls-1",
  "data-name": "Path 69",
  transform: "translate(-4 20)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_71",
  d: "M5.575-13.405L8.9-10H2.247z",
  className: "cls-1",
  "data-name": "Path 71",
  transform: "translate(-2.247 13.405)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-4"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_73",
  d: "M12-21h1.417v2.833H12z",
  className: "cls-1",
  "data-name": "Path 73",
  transform: "translate(-12 21)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_75",
  d: "M11.708-22h2.833a.708.708 0 0 1 .708.708.708.708 0 0 1-.708.708h-2.833a.708.708 0 0 1-.708-.708.708.708 0 0 1 .708-.708z",
  className: "cls-1",
  "data-name": "Path 75",
  transform: "translate(-11 22)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_77",
  d: "M15.675-8.145a1.128 1.128 0 0 0-.491-.924 4.873 4.873 0 0 0-1.655-.68 5.83 5.83 0 0 1-2.362-1.011 1.979 1.979 0 0 1-.742-1.584 2.023 2.023 0 0 1 .727-1.6 3.479 3.479 0 0 1 2-.746V-16h1.134v1.312a3.219 3.219 0 0 1 1.989.841 2.588 2.588 0 0 1 .711 1.926h-1.4a1.776 1.776 0 0 0-.51-1.336 1.892 1.892 0 0 0-1.377-.5 2.244 2.244 0 0 0-1.385.367 1.215 1.215 0 0 0-.479 1.023 1.132 1.132 0 0 0 .506.969 5.227 5.227 0 0 0 1.666.656 8.016 8.016 0 0 1 1.811.65 2.6 2.6 0 0 1 .959.826 1.97 1.97 0 0 1 .308 1.1 1.971 1.971 0 0 1-.772 1.622 3.928 3.928 0 0 1-2.164.728v1.139H13.02v-1.13A3.723 3.723 0 0 1 10.8-6.6a2.336 2.336 0 0 1-.8-1.87h1.407a1.544 1.544 0 0 0 .555 1.276 2.453 2.453 0 0 0 1.575.447 2.825 2.825 0 0 0 1.563-.372 1.169 1.169 0 0 0 .575-1.026z",
  className: "cls-2",
  "data-name": "Path 77",
  transform: "translate(-10 16)"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_110",
  "data-name": "Group 110",
  transform: "translate(0 24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_102",
  className: "cls-3",
  "data-name": "Group 102",
  transform: "translate(0 -24)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_66",
  d: "M-5-29h48.162v48.162H-5z",
  className: "cls-4",
  "data-name": "Path 66",
  transform: "translate(-2.083 21.917)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_104",
  className: "cls-5",
  "data-name": "Group 104",
  transform: "translate(5.666 -18.334)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_103",
  "data-name": "Group 103",
  transform: "rotate(90 12.04 12.04)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_68",
  d: "M12.041 24.081A12.041 12.041 0 1 0 0 12.041a11.751 11.751 0 0 0 2.774 7.668",
  className: "cls-6",
  "data-name": "Path 68"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_105",
  className: "cls-7",
  "data-name": "Group 105",
  transform: "translate(3.183 -8.992)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_70",
  d: "M-2.753-18.405h20.82V-.833h-20.82z",
  className: "cls-8",
  "data-name": "Path 70",
  transform: "translate(-4.33 11.322)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_106",
  className: "cls-9",
  "data-name": "Group 106",
  transform: "translate(16.998 -20.75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_72",
  d: "M7-26h15.582v17H7z",
  className: "cls-8",
  "data-name": "Path 72",
  transform: "translate(-14.083 18.917)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_107",
  className: "cls-10",
  "data-name": "Group 107",
  transform: "translate(15.582 -21.167)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_74",
  d: "M6-27h18.415v15.582H6z",
  className: "cls-8",
  "data-name": "Path 74",
  transform: "translate(-13.083 19.917)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_108",
  className: "cls-11",
  "data-name": "Group 108",
  transform: "translate(14.165 -12.668)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_76",
  d: "M5-21h21.248V4.5H5z",
  className: "cls-8",
  "data-name": "Path 76",
  transform: "translate(-12.083 13.917)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_109",
  "data-name": "Group 109",
  transform: "translate(14.165 -12.668)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  d: "M5.675 7.855a1.128 1.128 0 0 0-.491-.924 4.873 4.873 0 0 0-1.655-.68A5.83 5.83 0 0 1 1.168 5.24a1.979 1.979 0 0 1-.742-1.584 2.023 2.023 0 0 1 .727-1.6 3.479 3.479 0 0 1 2-.746V0h1.13v1.312a3.219 3.219 0 0 1 1.989.841 2.588 2.588 0 0 1 .712 1.927h-1.4a1.776 1.776 0 0 0-.51-1.336 1.892 1.892 0 0 0-1.377-.5 2.244 2.244 0 0 0-1.385.367 1.215 1.215 0 0 0-.479 1.023 1.132 1.132 0 0 0 .506.969 5.228 5.228 0 0 0 1.666.656 8.016 8.016 0 0 1 1.811.65 2.6 2.6 0 0 1 .959.826 1.97 1.97 0 0 1 .308 1.1 1.971 1.971 0 0 1-.772 1.622 3.928 3.928 0 0 1-2.164.728v1.139H3.02v-1.131A3.724 3.724 0 0 1 .8 9.4 2.336 2.336 0 0 1 0 7.533h1.407a1.544 1.544 0 0 0 .555 1.276 2.453 2.453 0 0 0 1.575.447A2.825 2.825 0 0 0 5.1 8.881a1.169 1.169 0 0 0 .575-1.026z",
  className: "cls-12",
  "data-name": "Path 78"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLoanDashboard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_loan_dashboard.9580b98454e072438a2523c9ec8aa451.svg";